// extracted by mini-css-extract-plugin
module.exports = {"FQAContainer":"FQA_FQAContainer__1Q5VP","leftContent":"FQA_leftContent__1B2tI","midContent":"FQA_midContent__2dMb6","rightContent":"FQA_rightContent__13RTw"};